module.exports = __webpack_public_path__ + "img/partnerRuanSer.c74a2de9.png";